// extracted by mini-css-extract-plugin
module.exports = {"block":"Text_block__1VM-S","line":"Text_line__2JZG0"};